import { getUser } from "./cookieStorage";

// get permissions from user object
const getPermissions = () => {
    const user = getUser();
    return user.permissions || [];
};

// implements hasPermission function
const hasPermission = (permission) => {
    const permissions = getPermissions();
    return permissions.includes(permission);
};

export { 
    getPermissions,
    hasPermission,
};